import React from 'react';
import Footer from '../components/Footer'

export default function PrivacyPolicy() {
  return (
    <div>
    <div className="bg-gray-100 min-h-screen py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto bg-white rounded-md p-6 md:p-8 text-gray-800">
        <h1 className="text-3xl font-bold mb-4 text-teal-600 border-b pb-2">Privacy Policy</h1>

        <p className="mb-4 text-xs text-gray-600">
          Last updated: {new Date().toLocaleDateString('en-US', {
            year: 'numeric', month: 'long', day: 'numeric'
          })}
        </p>

        <p className="mb-6 text-base leading-relaxed">
          At <span className="font-semibold text-teal-600">justoffplan.ai</span>, your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information.
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-teal-600 mb-2">Information Collection</h2>
            <p className="text-base text-gray-700">
              We collect information you provide when you subscribe to our newsletter, contact us, or use our services. This includes your name, email, and other relevant data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-teal-600 mb-2">Use of Information</h2>
            <p className="text-base text-gray-700">We use your information to:</p>
            <ul className="list-disc ml-5 mt-2 space-y-1 text-base text-gray-700">
              <li>Improve our services</li>
              <li>Respond to inquiries and support needs</li>
              <li>Send promotional emails or updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-teal-600 mb-2">Third-Party Sharing</h2>
            <p className="text-base text-gray-700">
              We do not sell or rent your data. We may share your information:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1 text-base text-gray-700">
              <li>With your consent</li>
              <li>When required by law</li>
              <li>To protect our rights or safety</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-teal-600 mb-2">Your Rights</h2>
            <p className="text-base text-gray-700">
              You can request access, updates, or deletion of your personal data anytime. Contact us below to exercise your rights.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-teal-600 mb-2">Contact</h2>
            <p className="text-base text-gray-700">
              For questions about this Privacy Policy, contact us at{' '}
              <a href="mailto:info@justoffplan.ai" className="text-teal-600 hover:underline font-medium">
                info@justoffplan.ai
              </a>.
            </p>
          </section>
        </div>
      </div>
     
    </div>
     <Footer />
     </div>
  );
}
